module.exports = __webpack_public_path__ + "static/img/apply8.da00c54b.png";